/**
 * (Группа 12) Настройки — профиль оператора и доступ команды.
 *
 * REAL частично: GET /v1/platform/me (профиль). Управление 2FA/backup-кодами,
 * активными сессиями и составом команды — TODO backend.
 */
import { PageStub } from '../../shared/PageStub.js';

export function SettingsPage(): JSX.Element {
  return (
    <PageStub
      testId="settings-page"
      title="Настройки"
      description="Профиль администратора и доступ внутренней команды."
      sections={[
        'Профиль: ФИО/email/телефон, роль, смена пароля',
        'Статус 2FA TOTP, число backup-кодов, активные сессии (устройство/локация)',
        'Доступ команды: участники в 4 пресетах (root/support/finance/readonly)',
      ]}
      dataSource="REAL GET /v1/platform/me; 2FA/сессии/команда — TODO backend"
    />
  );
}
